module.exports = __webpack_public_path__ + "static/img/cooperativePartner.c6946bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/cooperativePartner.jpg
// module id = mhBs
// module chunks = 1